const fmCertParser = /^(\d{6,9})\s+0?\d{11}$|^(\d{6,9})$|^0?\d{11}\s+(\d{6,9})$/
export function getInscriptionNo(lab, cert) {
    if (lab === 'FM' && fmCertParser.test(cert)) {
        const inscrMatch = fmCertParser.exec(cert)
        return inscrMatch[1] || inscrMatch[2] || inscrMatch[3]
    }
    else return null
}
